import { TDocumentDTO } from "src/services/api";

export function isSignedByCustomer(doc: TDocumentDTO) {
  return doc.status === "SIGNED" || doc.status === "AWAITING_APPROVAL";
}
